import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type ISuggestRequest,
  type ISuggestResponse,
  fetchSuggest,
} from '@/repositories/generated/shared/geo-suggest/v2/suggest';

export const fetchSuggestions = withTypeSafeApiResult<ISuggestRequest, ISuggestResponse>(fetchSuggest);
